import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C12LinkedListEnhancedProps = RenderingProps<
  C12LinkedListEnhancedFields,
  C12LinkedListEnhancedParams
>;

export type C12LinkedListEnhancedFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  Cta?: LinkField;
  SupportCopyBottom?: RichTextField;
};

export type C12LinkedListEnhancedParams = {
  HeadlineTag?: string;
  Columns?: string;
  CtaStyle?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
